import { CurrentContext } from '../types/currentContext';

/**
 * Securely filters a CurrentContext for logging purposes.
 * Only includes non-sensitive fields required for debugging/analytics.
 * Never log PII or sensitive patient data.
 */
export function filterLogContext(context: CurrentContext) {
  if (!context) {
    return {};
  }
  return {
    patient: context.patient
      ? {
          patientId: context.patient?.identifiers?.ehrPatientId,
          insurance: context.patient?.insurance
            ? {
                ehrInsurance: context.patient.insurance?.ehrInsurance,
                insurer: context.patient.insurance?.insurer,
              }
            : undefined,
          vimPatientId: context.patient?.identifiers?.vimPatientId,
        }
      : undefined,
    ...(context.selectedProvider && {
      selectedProvider: {
        providerEhrId:
          context.selectedProvider.ehrProviderId || (context.selectedProvider as any).providerEhrId,
        npi: context.selectedProvider.npi,
      },
    }),
    ...(context.transactionId && { transactionId: context.transactionId }),
  };
}
